<template>
      <div id="resources">
            <section class="section resources-hero animate__animated animate__fadeIn">
                  <BackButton link="/compare" />
                  <div class="grid-container max">
                        <div class="resources-grid">
                              <div class="resources-left">
                                    <h1>Online<br />resources</h1>
                                    <p class="resources-subtitle">Chat with an Anthem representative from the convenience of your home or office.</p>
                                    <p class="resources-desc">Available at no additional cost, Anthem&rsquo;s online tools offer you a safe, secure, personalized and interactive experience built around your health and benefits.</p>
                              </div>
                              <div class="resources-right">
                                    <div class="resources-box">
                                          <div class="resources-item">
                                                <img src="~@/assets/img/documents-icon.svg" alt="" />
                                                <h5>Compare Plan Options</h5>
                                                <p>The Benefits at a Glance flyer shows you a comparison of which Anthem plan might work best for you and your family.</p>
                                          </div>
                                          <div class="resources-item">
                                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" /></svg>
                                                <h5>Chat online</h5>
                                                <p>Chat with an Anthem representative from the convenience of your home or office.</p>
                                          </div>
                                          <div class="resources-item">
                                                <img src="~@/assets/img/stethoscope-find-care-icon.svg" alt="" />
                                                <h5>Find Care</h5>
                                                <p>Available with both the HMO and HRA Plan Options, the Find Care tool helps you locate an in-network doctor or facility near you.</p>
                                          </div>
                                          <div class="resources-item">
                                                <img src="~@/assets/img/total-health-connections-icon.svg" alt="" />
                                                <h5>Manage your health</h5>
                                                <p>Check the status of a claim, review medical benefits, chat with a Member Services representative, view your member ID card or take advantage of discounts on health products &mdash; available when you register online at <a href="https://www.anthem.com/shbp" target="_blank" @click="track('Link', 'anthem.com/shbp - Resources')">anthem.com/shbp</a>.</p>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <div class="resources-btn-wrap">
                        <router-link to="/sydney-health" class="resources-btn"><span>Next</span></router-link>
                  </div>
            </section>
      </div>
</template>
<script>
      import BackButton from "../components/BackButton"
      import gaEventMixin from "../mixins/gaEventMixin"
      export default {
            name: "SHBPResources",
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            },
            mixins: [gaEventMixin]
      }
</script>

<style lang="scss">
#resources {
      .resources-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 160px 0;
            position: relative;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .resources-grid {
                  display: flex;
                  flex-wrap: nowrap;
                  align-items: flex-start;
                  justify-content: space-between;
                  gap: 64px;
                  margin-top: 48px;
            }

            .resources-left {
                  flex: 1 1 400px;
                  max-width: 480px;
                  position: sticky;
                  top: 140px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(2.75rem, 4.5vw, 4.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 32px;
                  }

                  .resources-subtitle {
                        color: #012E58;
                        font-size: 1.25rem;
                        font-weight: 600;
                        line-height: 1.4;
                        margin-bottom: 20px;
                  }

                  .resources-desc {
                        color: #12130f;
                        font-size: 1rem;
                        line-height: 1.6;
                        margin-bottom: 0;
                  }
            }

            .resources-right {
                  flex: 1 1 420px;
                  max-width: 550px;
                  min-width: 0;

                  .resources-box {
                        background-color: #1355E9;
                        padding: 40px;
                  }

                  .resources-item {
                        margin-bottom: 40px;

                        &:last-child {
                              margin-bottom: 0;
                        }

                        img,
                        svg {
                              display: block;
                              width: 40px;
                              height: 40px;
                              object-fit: contain;
                              margin-bottom: 12px;
                              filter: brightness(0) invert(1);
                              color: #ffffff;
                        }

                        h5 {
                              color: #ffffff;
                              font-weight: 700;
                              font-size: 1.0625rem;
                              margin-bottom: 6px;
                        }

                        p {
                              color: rgba(255, 255, 255, 0.9);
                              font-size: 0.9375rem;
                              line-height: 1.5;
                              margin-bottom: 0;

                              a {
                                    color: #ffffff !important;
                                    font-weight: 700;
                                    text-decoration: underline;
                              }
                        }
                  }
            }

            .resources-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  background-color: #ffffff;
                  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
                  padding: 20px 0;
                  text-align: center;
            }

            .resources-btn {
                  display: block;
                  background-color: #1355E9;
                  color: #ffffff !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 330px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;
                  margin: 0 auto;

                  &:hover {
                        background-color: #44B8F3;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 140px 24px;

                  .back-btn {
                        left: 2rem;
                  }

                  .resources-grid {
                        flex-direction: column;
                        gap: 32px;
                        margin-top: 32px;
                  }

                  .resources-left {
                        flex: 0 0 auto;
                        max-width: 100%;
                        position: static;

                        h1 {
                              font-size: clamp(2rem, 8vw, 3rem) !important;
                        }
                  }

                  .resources-right {
                        flex: 0 0 auto;
                        max-width: 100%;

                        .resources-box {
                              padding: 32px 24px;
                        }
                  }
            }
      }
}
</style>
